import { Component, EventEmitter, input, Output, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faEye } from '@fortawesome/pro-solid-svg-icons';
import { CountData, CountHeader } from '@r1-compass-library/models/reporting/dashboard-count.model';

@Component({
    selector: 'r1-compass-app-dashboard-count',
    imports: [FontAwesomeModule, MatButtonModule],
    templateUrl: './dashboard-count.component.html',
    styleUrls: ['./dashboard-count.component.scss'],
})
export class DashboardCountComponent {
    header = input.required<CountHeader>();
    count = input.required<CountData>();

    @Output()
    viewDetails: EventEmitter<void> = new EventEmitter();

    constructor() {
        const library = inject(FaIconLibrary);

        library.addIcons(faEye);
    }
}
